<template>
  <div>
    <div class="themeBody">
      <div style="font-size: 40px;margin-left: 20px">{{ $t('DisplayPage.theme') }}</div>
      <el-button type="primary" @click="change(1)" style="margin-left: 20px">{{ $t('DisplayPage.darkTheme') }}</el-button>
      <el-button type="primary" @click="change(2)">{{ $t('DisplayPage.lightTheme') }}</el-button>
      <el-button type="primary" @click="change(3)">{{ $t('DisplayPage.gentleTheme') }}</el-button>
    </div>
    <div v-show="false">
      <div style="font-size: 40px;margin-left: 20px">{{ $t('DisplayPage.language') }}</div>
      <el-select v-model="language" class="themeLanguageSelect" style="margin-left: 20px">
        <el-option v-for="item in option" :value="item.value" :key="item.value" :label="item.label"></el-option>
      </el-select>
    </div>
  </div>
</template>

<script>
import {helper} from "joysun-frame";

export default {
  name: "Theme",
  data() {
    return {
      body_now: null,
      option: this.$store.state.core.languageList,
      language: this.$store.state.core.language,
    }
  },
  methods: {
    change: function (type) {
      if (type === 1) {
        document.getElementById('style').setAttribute("href", "css/one.css");
        localStorage.setItem("style", "css/one.css");
      } else if (type === 2) {
        document.getElementById('style').setAttribute("href", "css/two.css");
        localStorage.setItem("style", "css/two.css");
      } else {
        document.getElementById('style').setAttribute("href", "css/gentle.css");
        localStorage.setItem("style", "css/gentle.css");
      }
    }
  },
  watch: {
    language(val) {
      this.$i18n.locale = val
      this.$store.state.core.language = val
      helper.setLocalstorage('lang', val)
    }
  }
}
</script>

<style lang="less" scoped>
.themeBody {
  height: 100%;
  background: white;
  margin-bottom: 5vh;
}
</style>
